import {
  JOBGROUP_INTERVIEWER_FETCHING,
  JOBGROUP_INTERVIEWER_FAILED,
  JOBGROUP_INTERVIEWER_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case JOBGROUP_INTERVIEWER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case JOBGROUP_INTERVIEWER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case JOBGROUP_INTERVIEWER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
